import React from 'react';
import proptypes from 'prop-types';

const { string } = proptypes;

export const StorePodLoader = ({ height }) => {
  return (
    <div className="sui-animate-pulse">
      <div className="sui-w-auto sui-bg-strong sui-rounded-lg" style={{ height }} />
    </div>
  );
};

StorePodLoader.propTypes = {
  height: string
};

StorePodLoader.defaultProps = {
  height: '0.625rem'
};

StorePodLoader.displayName = 'StorePodLoader';
